/* (c) Dalineage, s.r.o. 2020-2025, all rights reserved */
package com.dalineage.client.batchtree

import scala.collection.immutable._

import org.scalajs.dom

import typings.gojs.{mod => go}
import scala.scalajs.js
import org.scalablytyped.runtime.StringDictionary

import com.dalineage.common
import common.adt.ExplorerDataADT._

import com.dalineage.client
import client.adt.TreeExplorerADT
import client.adt.PropertyPanelADT

import scala.util.chaining._

object BatchTreeComponent {
  import TreeExplorerADT.TreeExplorerUserAction
  import TreeExplorerADT.TreeNode

  case object ProcessedBatch extends TreeExplorerADT.NodeType
  case object SavedView extends TreeExplorerADT.NodeType
  case object Directory extends TreeExplorerADT.NodeType

  var batchTreeDiv: dom.html.Div = null
  var treeExplorerDiv: TreeExplorer.TreeExplorerDiv = null
  var userActionFn: TreeExplorerUserAction => Unit = null

  def msg(s: String): Unit = { batchTreeDiv.innerHTML = s }

  def init(div: dom.html.Div, userActionFn: TreeExplorerUserAction => Unit): Unit = {
    batchTreeDiv = div
    div.style.backgroundColor = client.CSS.backgroundColor("explorer-window")
    div.tabIndex = 5
    div.id = "batch-tree"
    treeExplorerDiv = TreeExplorer.TreeExplorerDiv(div)
    this.userActionFn = userActionFn
  }

  def open(explorerData: ExplorerData, optBatchId: Option[String], optDir: Option[String]): Unit = {

    def dirToTree(dir: ExplorerDir, path: String): TreeNode = {
      val children = dir.nodes.map{ child =>
        child match
          case subdir: ExplorerDir =>
            val properties = BatchTreeContextMenu.menu(subdir)
            dirToTree(subdir, path + "/" + dir.name).copy(properties = properties)
          case batch: ProcessedBatch =>
            val properties = BatchTreeContextMenu.menu(batch)
            val expanded = optBatchId.map(batch.info.id == _).getOrElse(false)
            optBatchId
              .filter(batch.info.id == _)
              .map ( _ => client.diagram.GoJSDiagram.batchInfo = Some(batch.info))
            TreeNode(ProcessedBatch, batch.info.id, batch.info.name, properties, Nil, expanded)
          //tbd views
      }
      val expanded = children.exists(_.expanded)
      val properties = BatchTreeContextMenu.menu(dir)
      TreeNode(Directory, path + "/" + dir.name, dir.name, properties, children, expanded)
    }
    val children = explorerData.dirs.map{ child => dirToTree(child, "") }
    val treeData = TreeNode(Directory, "root", "Select batch", Nil, children, true)
    treeExplorerDiv.renderTree(treeData, userActionFn)

    optBatchId match
      case None =>
        selectDirectory(optDir.getOrElse("/public"))
        batchTreeDiv.focus()
      case Some(_) =>

  }

  def selectDirectory(dir: String): Unit =
    val node = treeExplorerDiv.expandElementsByKey(dir).get
    treeExplorerDiv.selectNode(node)
    node.parentElement.classList.add("expanded")
}
